// Wake lock with auto re-acquire on visibility change. No-op when unsupported.

let sentinel: WakeLockSentinel | null = null;
let wanted = false; // re-acquire only if the caller explicitly asked for it

type WakeLockNav = Navigator & { wakeLock?: { request(type: 'screen'): Promise<WakeLockSentinel> } };

export function isSupported(): boolean {
  return 'wakeLock' in navigator && !!(navigator as WakeLockNav).wakeLock;
}

export function isActive(): boolean {
  return sentinel !== null;
}

export async function acquire() {
  wanted = true;
  const nav = navigator as WakeLockNav;
  if (!nav.wakeLock) return;
  try {
    sentinel = await nav.wakeLock.request('screen');
    sentinel.addEventListener('release', () => {
      sentinel = null;
    });
  } catch {
    sentinel = null;
  }
}

export async function release() {
  wanted = false;
  try {
    await sentinel?.release();
  } catch {
    /* ignore */
  }
  sentinel = null;
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && wanted && !sentinel) {
    void acquire();
  }
});
